(() => {
  if (window.FoodyText) return;
  const names = ['data-ft-key', 'data-ft-owner', 'data-ft-mobile', 'data-ft-desktop', 'data-ft-color'];
  const vars = ['--ft-mobile', '--ft-desktop', '--ft-color'];
  window.FoodyText = {
    set(element, value, source) {
      if (!element) return;
      const text = String(value ?? '');
      const section = element.closest('.shopify-section') || source?.closest('.shopify-section');
      const current = element.querySelector('foody-text') || element;
      const key = current.dataset.ftKey;
      const owner = source?.dataset.ftSource || current.dataset.ftOwner;
      const records = [...(section?.querySelectorAll('template[data-ft-record]') || [])];
      const matching = records.filter(record => text.trim() && record.content.textContent.trim() === text.trim());
      const record = matching.find(r => r.dataset.ftKey === key && (!owner || r.dataset.ftOwner === owner)) || matching.find(r => owner && r.dataset.ftOwner === owner) || matching.find(r => !r.dataset.ftOwner) || matching[0] || records.find(r => key && r.dataset.ftKey === key && (!owner || r.dataset.ftOwner === owner)) || current;
      const attributes = names.map(name => [name, record.getAttribute(name)]);
      const values = vars.map(name => [name, record.style.getPropertyValue(name)]);
      element.textContent = text;
      for (const [name, val] of attributes) { if (val === null) element.removeAttribute(name); else element.setAttribute(name, val); }
      for (const [name, val] of values) { if (val) element.style.setProperty(name, val); else element.style.removeProperty(name); }
      return value;
    }
  };
})();
